// extracted by mini-css-extract-plugin
export default {"listSmallFields":"About_listSmallFields__z76aS","listBlock":"About_listBlock__BX-74","listTextAreaFields":"About_listTextAreaFields__yLsQE"};